/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function AIContinueWriting({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g stroke="currentColor" strokeLinecap="round" strokeWidth={1.2} clipPath="url(#AIContinueWriting_svg__a)"><path d="M1.125 15h13.75" /><path strokeLinejoin="round" d="M8.716 1.414a2 2 0 0 1 2.829 0l.353.354a2 2 0 0 1 0 2.828L5.496 11a2 2 0 0 1-1.034.55l-3.347.649.65-3.348a2 2 0 0 1 .549-1.033zM2.706 8.132l2.475 2.475" /></g><defs><clipPath id="AIContinueWriting_svg__a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></svg>;
}
;